import { render, staticRenderFns } from "./EditProxy.vue?vue&type=template&id=e6ad735a"
import script from "./EditProxy.vue?vue&type=script&lang=js"
export * from "./EditProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports